import React from "react";
import { Link } from "react-router-dom";
import { Dropdown, Button, Layout, Menu } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useAuth } from "../../../contexts/auth";
const { Header } = Layout;

const Topbar = () => {
  const auth = useAuth();
  const user = auth.loggedInUser;
  const userRole = user?.role;

  const onClick = (e) => {
    const { key } = e;
    switch (key) {
      case "logout":
        return auth.logout();
      default:
        console.log("no handler");
        break;
    }
  };
  const menu = (
    <Menu onClick={onClick}>
      <Menu.Item key="logout">Logout</Menu.Item>
    </Menu>
  );

  return (
    <Header style={{ padding: 0 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          height: "100%",
          paddingRight: 20,
        }}
      >
        {userRole !== "company_admin" && (
          <div style={{ padding: "0 20px" }}>
            <Link to="/labPortal/review-reports/" target="_blank">
              <span style={{ color: "#fff" }}>Lab Portal</span>
            </Link>
          </div>
        )}
        {/* <div style={{ padding: "0 20px" }}>
          <Link
            to="/result-validator" target="_blank"
          >
            <span style={{ color: "#fff" }}>Result Validator</span>
          </Link>
        </div> */}
        <div style={{ padding: "0 20px" }}>
          <a
            href="https://portal-help.foodlabz.ai/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span style={{ color: "#fff" }}>Help Centre</span>
          </a>
        </div>

        <div style={{ padding: "0 20px" }}>
          <span style={{ color: "#fff" }}>Hello {user.firstName}!</span>
        </div>
        <Dropdown overlay={menu} trigger={["click"]}>
          <Button
            onClick={(e) => e.preventDefault()}
            type="secondary"
            shape="circle"
            icon={<UserOutlined />}
          />
        </Dropdown>
      </div>
    </Header>
  );
};

export default Topbar;
